export const LOCAL_STORAGE_KEYS = {
  CURRENT_ORGANISATION: 'infpl.current.organisation.v1',
  PLANNEN_FILTERS: 'filter.plannen.v1',
  AFSTEMMINGSDOSSIERS_FILTERS: 'filter.afstemmingsdossiers.v1',
  BERICHTENCENTRUM_FILTERS: 'filter.berichtencentrum.v1',
  SYSTEM_NOTICES_READ: 'infpl.system-notices.read.v1',
} as const;

// Deze keys worden gereset zodra de actieve organisatie wijzigt.
export const ORGANISATIE_SWITCH_RESET_KEYS: string[] = [
  LOCAL_STORAGE_KEYS.PLANNEN_FILTERS,
  LOCAL_STORAGE_KEYS.AFSTEMMINGSDOSSIERS_FILTERS,
  LOCAL_STORAGE_KEYS.BERICHTENCENTRUM_FILTERS,
];

// Paginagrootte-voorkeur per overzicht. Deze blijft bewust behouden bij het wisselen van organisatie.
export const pageSizeStorageKey = (overviewId: string): string => `pagesize.${overviewId}.v1`;
